// extracted by mini-css-extract-plugin
export default {"row":"TwoColumnLayout_row__xqKvY","firstColumn":"TwoColumnLayout_firstColumn__GgkIp","secondColumn":"TwoColumnLayout_secondColumn__f64TP"};